<template>
	<!-- The login view transitions to the next view by expanding the content div to fit the element,
 		 by triggering it with the "success" class - see transition named "success" below -->
	<div class="auth logo" :style="getUserType === 'observer' ? 'background: linear-gradient(28.06deg, #3F5CBD 7.71%, #1BC8CE 126.22%)' : ''">
		<div class="auth-container">
			<router-link class="login-back" v-if="$route.name === 'reset'" to="/login">
				<i class="el-icon-back"></i>
				Login
			</router-link>
			<div class="loading-para" v-if="success">
				<LoadingSpinnerIcon class="loading-icon" type="primary"></LoadingSpinnerIcon>
				<span>Loading DoctorPlan</span>
				<span class="small">Securely logging in…</span>
			</div>
			<div class="loading-para" v-if="logout">
				<LoadingSpinnerIcon class="loading-icon" type="primary"></LoadingSpinnerIcon>
				<span>Logging out of DoctorPlan</span>
				<span class="small">Securely logging out…</span>
			</div>

			<img class="logo" v-if="getUserType === 'observer'" :src="require('@/module/dashboard/navbar/image/safe_logo.png')" />
			<img class="logo" v-else :src="require('@/module/dashboard/navbar/image/logo.png')" />

			<div class="logo-title">
				<span v-if="getUserType === 'observer'" style="color: #3572B9">Powerful Clinical Intelligence</span>
				<template v-else>Create <b>deep relationships</b> with patients, between visits</template>
			</div>
			<!-- The .form that has the username and password fields -->
			<div v-bind:class="['form', { success }]"
				ref="form"
				v-bind:is="formType"
				v-bind:query="query"
				@success="success = true">
			</div>
			<div class="bottom-para">
				<span>
					<SafeCertifyIcon v-if="getUserType === 'observer'"></SafeCertifyIcon>
					<CertifyIcon v-else></CertifyIcon>
					For your security, you will be logged out automatically after 30 minutes of inactivity.
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Logo from './Logo.vue'
import CertifyIcon from './form/icons/Certify'
import SafeCertifyIcon from './form/icons/SafeCertify'
import LoadingSpinnerIcon from '@/module/component/icon/LoadSpinner.vue'

import Forms from './form/components'

export default {
	name: 'login',

	props: {
		form: {
			type: String,
			required: true
		},
		query: {
			type: Object
		},
		logout: {
			type: Boolean
		}
	},

	data() {
		return {
			active: false,
			logo: true,
			success: false
		}
	},

	computed: {
		...mapState('auth', [
			'authenticated'
		]),
		...mapGetters(['getUserType']),
		formType() {
			return this.form + 'Form'
		}
	},

	mounted() {
		this.active = true

		if (this.logout) {
			this.$store.dispatch('auth/logout')
			.then(() => {
				this.$router.replace('/login')
			})
			.catch(() => {
				this.$router.replace('/login')
			})
		}
	},

	components: {
		Logo,
		CertifyIcon,
		SafeCertifyIcon,
		LoadingSpinnerIcon,
		...Forms
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
